import React from "react";
import { useContent } from "@/hooks/useContent";
import { STATS_DEFAULTS } from "@/lib/contentDefaults";

// Social-proof metrics band. Renders nothing until the client enables it and fills real numbers.
export const StatsBand = ({ variant = "light" }) => {
  const s = useContent("nj_stats", STATS_DEFAULTS);
  const items = (s.items || []).filter((it) => it.value && String(it.value).trim());
  if (!s.show || items.length === 0) return null;
  const dark = variant === "dark";
  return (
    <section data-testid="nj-stats" className={dark ? "bg-nj-dark" : "bg-nj-olive/40"}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-10">
          <span className="text-nj-gold text-xs tracking-[0.28em] uppercase font-semibold">{s.title}</span>
          {s.subtitle && <p className={`mt-3 text-base ${dark ? "text-white/75" : "text-nj-text2"}`}>{s.subtitle}</p>}
        </div>
        <div className="flex flex-wrap justify-center gap-6">
          {items.map((it, i) => (
            <div
              key={it.id || i}
              data-testid={`nj-stat-${i}`}
              className={`flex-1 min-w-[150px] max-w-[230px] text-center px-4 py-7 rounded-md transition-transform hover:-translate-y-1 ${dark ? "bg-white/[0.06]" : "bg-white border border-nj-olive"}`}
            >
              <div className={`font-serif text-4xl sm:text-5xl leading-none ${dark ? "text-nj-gold" : "text-nj-primary"}`}>{it.value}</div>
              <div className={`text-sm mt-3 leading-snug ${dark ? "text-white/70" : "text-nj-muted"}`}>{it.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBand;
